import { useEffect, useState } from "react";
import { CustomTag, Modal, ShareComponent } from "@aph/ui-lib-humanx";
import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import styles from "@/components/ShareModal/ShareIconModal.module.scss";

const ShareIconModal = ({ openPopup, setOpenPopup }) => {
  const [isShowSuccessAlert, setIsShowSuccessAlert] = useState(false);

  const handleClose = () => {
    setOpenPopup(false);
  };

  useEffect(() => {
    let timer;

    if (isShowSuccessAlert) {
      timer = setTimeout(() => {
        setIsShowSuccessAlert(false); // Clear the message
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [isShowSuccessAlert]);

  useEffect(() => {
    return () => {
      setIsShowSuccessAlert(false);
    };
  }, []);

  return (
    <>
      <Modal
        open={openPopup}
        size="sm"
        handleOpen={handleClose}
        mobileBottomAlign={true}
        title={"Share"}
        backdropClose={true}
        titleClass={styles.titleClass}
        titleAlign="left"
      >
        <ShareComponent
          data={[
            {
              leadingIcon: `${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_copy_icon.svg`,
              alt: "Copy Link",
              shareLinkText: "Copy Link",
              onClick: () => {
                navigator.clipboard.writeText(window.location.href);
                setIsShowSuccessAlert(true);
              },
            },
            {
              leadingIcon: `${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_whatsapp_icon.svg`,
              alt: "Whatsapp",
              shareLinkText: "Whatsapp",
              onClick: () => window.open(`https://web.whatsapp.com/send?text=${window.location.href}`),
            },
            {
              leadingIcon: `${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_facebook_icon.svg`,
              shareLinkText: "Facebook",
              alt: "Facebook",
              onClick: () => window.open(`http://www.facebook.com/sharer/sharer.php?u=${window.location.href}`),
            },
            {
              leadingIcon: `${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_twitter_icon.svg`,

              shareLinkText: "X",
              alt: "X",
              onClick: () => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}`),
            },
            {
              leadingIcon: `${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_email_icon.svg`,
              alt: "Email",
              shareLinkText: "Email",
              onClick: () => window.open(`mailto:?subject=&body=${window.location.href}.`),
            },
            {
              leadingIcon: `${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_telegram.svg`,
              alt: "Telegram",
              shareLinkText: "Telegram",
              onClick: () => window.open(`https://telegram.me/share/url?url=${window.location.href}`),
            },
            //not work for http url in Linkedin
            {
              leadingIcon: `${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_linkedin.svg`,
              alt: "Linkedin",
              shareLinkText: "Linkedin",
              onClick: () =>
                window.open(
                  `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`
                ),
            },
          ]}
        />

        {isShowSuccessAlert && (
          <CustomTag
            tagText="Link copied to clipboard"
            borderRadius="8px"
            border="1px solid #BEBEBB"
            tagHeight="52px"
            fontSize={14}
            fontWeight={400}
            backgroundColor="#fff"
            fontColor="#121414"
            spacing="16px 32px"
            className={styles.alertMesage}
          />
        )}
      </Modal>
    </>
  );
};

export default ShareIconModal;
